import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import StorageForm from '../Form';
import { createStorage } from '@resources/Storage/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createStorage, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createStorage(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.storage.create',
						defaultMessage:
							'A new Storage has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.storage',
					defaultMessage: 'Create Storage',
				})}
			</Title>
			<Section className="mb-5">
				<StorageForm
					{...props}
					onSubmit={handleSubmit}
					module={module}
				/>
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createStorage,
})(Create);
